import React from 'react';
import PropTypes from 'prop-types';

import SwitchComponent from './SwitchComponent';
import useStyles from './styles';


const Switch = ({
  id, title, value, setFieldValue, disabled, onToggle, error
}) => {
  const handleChange = () => {
    setFieldValue(id, !value);
    onToggle && onToggle();
  };

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <span className={classes.title}>
        {title}
      </span>
      <SwitchComponent
        id={id}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
        error={error}
      />
    </div>
  );
};


Switch.defaultProps = {
  disabled: false,
  value: false,
  error: false,
};

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default Switch;
